import { Component, OnInit, DoCheck, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Widget, ValueForm } from '../../../models/form';
import { FormControl, Validators, FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-date-picker-input',
  templateUrl: './date-picker-input.component.html',
  styleUrls: ['./date-picker-input.component.scss']
})
export class DatePickerInputComponent implements OnInit {

  constructor() { }
  @Input() widget: Widget;
  @Input() data: string = null;
  @Output() updateData = new EventEmitter();

  private ownData: Date

  ngOnInit() {
    this.ownData = this.stringToDate(this.data);
  }

  dateChange(ev) {
    if (ev) {
      let date: Date = ev.value;
      this.data = this.dateToString(date);
      this.updateData.emit(this.data);
    }
  }


  dateToString(date: Date) {
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString();
    if (month.length == 1) {
      month = "0" + month;
    }

    let day = date.getDate().toString();
    if (day.length == 1) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  }

  stringToDate(dateString: string) {
    if (dateString == null) {
      return null;
    }
    let date = new Date();
    let splited = dateString.split("-");
    let year = parseInt(splited[0]);
    let month = parseInt(splited[1]);
    let day = parseInt(splited[2]);
    date.setDate(day);
    date.setFullYear(year);
    date.setMonth(month - 1);
    return date;
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/form/date-picker-input/date-picker-input.component.ts